import {Dispatch, SetStateAction} from 'react'

export type SortKeys<T> = Extract<keyof T, string>;

export type SortOrder = 'asc' | 'desc';
export type SortProps<T> = {
    sortKey: SortKeys<T>,
    reverse: boolean
}

interface SortTypes<T> extends SortProps<T> {
    data: T[]
    sortKey: SortKeys<T>
    reverse: boolean
}

type PropsChangeSort<T> = {
    key: SortKeys<T>;
    sortOrder: SortOrder
    setSortOrder: Dispatch<SetStateAction<SortOrder>>;
    setSortKey: Dispatch<SetStateAction<SortKeys<T>>>;
}

export type Headers<T> = {
    key: SortKeys<T>
    label: string
    className: string
}

export function Sort<T extends Record<string, any>>({data, sortKey, reverse}: SortTypes<T>): T[] {

    const dateKeys = new Set(['called_at', 'created_at', 'archived_at', 'dateHour'])


    return [...data].sort((a, b) => {

        let aValue = a[sortKey];
        let bValue = b[sortKey];


        // Handle sorting by date fields
        if (dateKeys.has(sortKey)) {
            const dateA = aValue ? new Date(aValue).getTime() : 0;
            const dateB = bValue ? new Date(bValue).getTime() : 0;

            return reverse ? dateB - dateA : dateA - dateB;
        }

        // Handle string comparison
        if (typeof aValue === 'string' && typeof bValue === 'string') {
            return reverse
                ? bValue.localeCompare(aValue)
                : aValue.localeCompare(bValue);
        }

        // Handle number comparison
        if (typeof aValue === 'number' && typeof bValue === 'number') {
            return reverse ? bValue - aValue : aValue - bValue;
        }

        // Fallback for non-string, non-number types
        return 0
    })
}


export function handleSortChange<T>({key, sortOrder, setSortOrder, setSortKey}: PropsChangeSort<T>) {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    setSortKey(key)
}